module.exports = __webpack_public_path__ + "img/new-logo-large.0cde9071.png";